module.exports = __webpack_public_path__ + "static/img/brilix_home.d422dd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/brilix_home.png
// module id = ZBV2
// module chunks = 4